/* Homepage V2 progressive loader: keeps below-fold proof, pricing and credential work off the critical path. */
(function () {
  "use strict";

  var root = document.querySelector(".drsknn-v5--homepage-v2[data-drsknn-v5]");
  if (!root || root.dataset.homePerformanceReady === "true") return;
  root.dataset.homePerformanceReady = "true";

  var scriptPromises = {};
  var pricingPromise = null;
  var proofPromise = null;
  var credentialPromise = null;
  var pricingPanelSource = null;
  var pricingPanelTemplate = null;
  var pricingStyleCopies = [];

  function parkPricingPanels(source) {
    if (pricingPanelTemplate || !source || typeof window.openDrSknnPricingModal !== "function" || !window.DrSknnPricingExperience) return;
    // Mixed asset versions retain the original source until the reader supports it.
    if (!window.DrSknnPricingV3 || window.DrSknnPricingV3.supportsHomepagePanelCache !== true) return;
    var panels = source.querySelector("[data-pricing-panel-source][hidden]");
    var hub = source.querySelector('[data-pricing-landing-mode="true"]');
    if (!panels || !hub || !panels.parentNode) return;
    // Do not change ownership if an early interaction has already moved a panel.
    if (Array.prototype.some.call(document.querySelectorAll("[data-price-panel]"), function (panel) { return !panels.contains(panel); })) return;
    // All legacy initializers have already captured their nodes and listeners.
    // Keep the original container: the shared modal returns inactive panels here.
    var template = document.createElement("template");
    template.setAttribute("data-home-pricing-panel-cache", "");
    panels.parentNode.insertBefore(template, panels);
    pricingPanelSource = panels;
    pricingPanelTemplate = template;
    // Embedded panel styles must remain active even while their tables are inert.
    // Copies retain source order; original style nodes stay with their panels.
    panels.querySelectorAll('style, link[rel="stylesheet"]').forEach(function (style) {
      var copy = style.cloneNode(true);
      copy.setAttribute("data-home-pricing-style-copy", "");
      template.parentNode.insertBefore(copy, template);
      pricingStyleCopies.push(copy);
    });
    template.content.appendChild(panels);
  }

  function findPricingPanel(key) {
    if (!pricingPanelSource) return null;
    return Array.prototype.find.call(pricingPanelSource.querySelectorAll("[data-price-panel]"), function (panel) {
      return panel.getAttribute("data-price-panel") === key;
    }) || null;
  }

  function restorePricingPanels() {
    if (!pricingPanelTemplate || !pricingPanelTemplate.parentNode) return false;
    pricingPanelTemplate.parentNode.insertBefore(pricingPanelSource, pricingPanelTemplate);
    pricingPanelTemplate.remove();
    pricingStyleCopies.forEach(function (style) { style.remove(); });
    pricingStyleCopies = [];
    pricingPanelSource = null;
    pricingPanelTemplate = null;
    return true;
  }

  function loadScript(src, marker) {
    if (!src) return Promise.resolve(false);
    var key = marker || src;
    if (scriptPromises[key]) return scriptPromises[key];
    var existing = document.querySelector('script[data-home-lazy-script="' + key + '"]');
    if (existing) return Promise.resolve(true);

    scriptPromises[key] = new Promise(function (resolve) {
      var script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.homeLazyScript = key;
      script.onload = function () { resolve(true); };
      script.onerror = function () { resolve(false); };
      document.head.appendChild(script);
    });
    return scriptPromises[key];
  }

  function activateTemplateScripts(container) {
    var scripts = Array.prototype.slice.call(container.querySelectorAll("script"));
    return scripts.reduce(function (chain, oldScript, index) {
      return chain.then(function () {
        return new Promise(function (resolve) {
          var script = document.createElement("script");
          Array.prototype.slice.call(oldScript.attributes).forEach(function (attribute) {
            script.setAttribute(attribute.name, attribute.value);
          });
          script.dataset.homeHydratedScript = String(index + 1);
          if (oldScript.src) {
            script.onload = function () { resolve(true); };
            script.onerror = function () { resolve(false); };
          } else {
            script.textContent = oldScript.textContent;
          }
          oldScript.replaceWith(script);
          if (!oldScript.src) resolve(true);
        });
      });
    }, Promise.resolve());
  }

  function hydratePricing() {
    if (pricingPromise) return pricingPromise;
    var pricing = root.querySelector("[data-drsknn-pricing-v3-embedded]");
    if (!pricing) return Promise.resolve(false);
    var source = root.querySelector("[data-drsknn-pricing-v3-source]");
    var controllerSrc = pricing.getAttribute("data-pricing-v3-script-src") || "";
    var sourceUrl = pricing.getAttribute("data-pricing-v3-source-url") || "";

    pricing.dataset.homeLoading = "true";
    pricingPromise = Promise.resolve().then(function () {
      if (!source || source.firstElementChild) return true;
      return fetch(sourceUrl, { credentials: "same-origin", cache: "no-cache" })
        .then(function (response) {
          if (!response.ok) throw new Error("Pricing source unavailable");
          return response.text();
        }).then(function (html) {
          var parsed = new window.DOMParser().parseFromString(html, "text/html");
          var remoteSource = parsed.querySelector("[data-drsknn-pricing-v3-source]");
          if (!remoteSource) throw new Error("Pricing source missing");
          source.innerHTML = remoteSource.innerHTML;
          return true;
        });
    }).then(function () {
      return source ? activateTemplateScripts(source) : true;
    }).then(function () {
      return loadScript(controllerSrc, "pricing-v3");
    }).then(function (loaded) {
      if (loaded) parkPricingPanels(source);
      else restorePricingPanels();
      pricing.dataset.homeLoading = "false";
      pricing.dataset.homeLoaded = loaded ? "true" : "failed";
      return loaded;
    }).catch(function () {
      restorePricingPanels();
      pricing.dataset.homeLoading = "false";
      pricing.dataset.homeLoaded = "failed";
      var areaGrid = pricing.querySelector("[data-pv3-area-grid]");
      if (areaGrid) areaGrid.innerHTML = '<p class="drsknn-pricing-v3__loading" role="status">Prices could not load. <a href="/pages/dr-sknn-pricing-v3-preview">Open the full price list</a>.</p>';
      return false;
    });
    return pricingPromise;
  }

  function hydrateProofEnhancements() {
    if (proofPromise) return proofPromise;
    var coreProof = typeof window.DrSknnV5LoadProof === "function"
      ? window.DrSknnV5LoadProof()
      : Promise.resolve(false);
    proofPromise = Promise.all([
      coreProof,
      loadScript(root.getAttribute("data-home-proof-video-data-src"), "origin-video-data")
    ]).then(function () {
        return loadScript(root.getAttribute("data-home-proof-controller-src"), "proof-v3");
      })
      .then(function () {
        return loadScript(root.getAttribute("data-home-origin-controller-src"), "origin-journeys");
      }).then(function (loaded) {
        root.dataset.homeProofLoaded = loaded ? "true" : "failed";
        return loaded;
      });
    return proofPromise;
  }

  function hydrateCredentials() {
    if (credentialPromise) return credentialPromise;
    var credentials = root.querySelector("[data-drsknn-credential-root][data-credential-script-src]");
    if (!credentials) return Promise.resolve(false);
    credentialPromise = loadScript(credentials.getAttribute("data-credential-script-src"), "credentials").then(function (loaded) {
      credentials.dataset.homeLoaded = loaded ? "true" : "failed";
      return loaded;
    });
    return credentialPromise;
  }

  function observeNear(element, callback, margin) {
    if (!element) return;
    if (typeof window.IntersectionObserver !== "function") return;
    var confirmationTimer = null;
    var observer = new window.IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      if (confirmationTimer) return;
      confirmationTimer = window.setTimeout(function () {
        confirmationTimer = null;
        var rect = element.getBoundingClientRect();
        var safeMargin = typeof margin === "number" ? margin : 600;
        if (rect.top > window.innerHeight + safeMargin || rect.bottom < -safeMargin) return;
        observer.disconnect();
        callback();
      }, 300);
    }, { rootMargin: (typeof margin === "number" ? margin : 600) + "px 0px" });
    observer.observe(element);
  }

  function primeOnIntent(element, callback) {
    if (!element) return;
    ["pointerenter", "touchstart", "focusin"].forEach(function (type) {
      element.addEventListener(type, callback, { once: true, passive: true });
    });
  }

  var proof = root.querySelector("#drsknn-home-v2-proof");
  var pricing = root.querySelector("[data-drsknn-pricing-v3-embedded]");
  var doctor = root.querySelector("#drsknn-home-v2-doctor");

  // Let the above-fold layout settle before observing proof. Without this short
  // delay, early layout shifts can make the browser briefly treat the studio as
  // near the viewport and start the full proof bundle on first paint.
  window.setTimeout(function () {
    observeNear(proof, hydrateProofEnhancements, 0);
  }, 1800);
  observeNear(pricing, hydratePricing, 1100);
  observeNear(doctor, hydrateCredentials, 600);
  primeOnIntent(proof, hydrateProofEnhancements);
  primeOnIntent(pricing, hydratePricing);
  primeOnIntent(doctor, hydrateCredentials);

  if (proof) {
    proof.addEventListener("click", function (event) {
      if (root.dataset.homeProofLoaded === "true" || root.dataset.homeProofLoaded === "failed" || event.target.closest("[data-v5-open-consultation]")) return;
      var control = event.target.closest("button, a");
      if (!control) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      hydrateProofEnhancements().then(function () { control.click(); });
    }, true);
  }

  if (pricing) {
    pricing.addEventListener("click", function (event) {
      if (pricing.dataset.homeLoaded === "true" || pricing.dataset.homeLoaded === "failed") return;
      var control = event.target.closest("button, a, input");
      if (!control) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      hydratePricing().then(function (loaded) {
        if (!loaded) return;
        if (control.matches("input")) control.focus();
        else control.click();
      });
    }, true);
  }

  if (doctor) {
    doctor.addEventListener("click", function (event) {
      var credentials = root.querySelector("[data-drsknn-credential-root]");
      if ((credentials && (credentials.dataset.homeLoaded === "true" || credentials.dataset.homeLoaded === "failed")) || !event.target.closest("[data-drsknn-credential-open]")) return;
      var control = event.target.closest("[data-drsknn-credential-open]");
      event.preventDefault();
      event.stopImmediatePropagation();
      hydrateCredentials().then(function () { control.click(); });
    }, true);
  }

  window.DrSknnHomepageV2Performance = {
    loadProof: hydrateProofEnhancements,
    loadPricing: hydratePricing,
    findPricingPanel: findPricingPanel,
    restorePricingPanels: restorePricingPanels,
    loadCredentials: hydrateCredentials
  };
})();
